import {WidgetController} from './../widget';
import {byCountySummary} from '../../../services/arsweb/RoutingPaths';

import countryMapTemplate from './countryMapWidget.html';
import { CONSOLIDATION_CURRENCY_PARAMS } from "../../../controller/CommonViewController";

/** @ngInject */
export function countryMap() {
    return {
        restrict: 'E',
        scope: {
            controller: '='
        },
        transclude: 'true',
        templateUrl: countryMapTemplate,
        controller: CountryMapController,
        controllerAs: 'countryMapController'
    };
}

export class CountryMapController extends WidgetController {
    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, 'WIDGET_COUNTRYMAP', 'mdi-social-public', 'countryWdgtKey');

        // Listen to consolidation currency selection change
        $scope.$on('consolidationCurrency.change', () => {
            if(this.$scope.controller) {
                this.accountService.service.config.params = {};
                this.loadWidgetContent();
            }
        });
    }

    loadWidgetContent() {
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] =
            this.$scope.controller.$scope.consolitationcurrency.code;
        this.accountService.getUserSummaryData(byCountySummary)
            .then((accountData) => this.$scope.worldmapdata = accountData);
    }
}
